import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import BudgetStocksInFocusLive from '../../collection-templates/budget-stocks-in-focus-live';
import { isEmpty } from 'lodash';

const StocksInFocusLiveFullWidget = (props) => {
  const [collectionData, setCollectionData] = useState({});
  const [darkMode, setDarkMode] = useState(false);
  const [lightMode, setLightMode] = useState(false);
  const queryClient = new QueryClient;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dm = urlParams.get('dm');
    const disabledm = urlParams.get('disabledm');

    if (dm == 1) {
      setDarkMode(true);
      setLightMode(false);
    } else if (disabledm == 1) {
      setDarkMode(false);
      setLightMode(true);
    } else {
      setDarkMode(false);
      setLightMode(false);
    }
    const getCollectionData = async () => {
      if (isEmpty(collectionData)) {
        try {
          const response = await fetch('https://www.ndtvprofit.com/api/v1/collections/stocks-radar').then(res => res.json());
          setCollectionData(response);
        } catch (e) {
          console.log('Error in api');
        }
      }
    }

    getCollectionData();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {!isEmpty(collectionData) && (
        <BudgetStocksInFocusLive
          collection={collectionData}
          widget={true}
          darkMode={darkMode}
          lightMode={lightMode}
          {...props}/>
      )}
    </QueryClientProvider>
  );
};

export { StocksInFocusLiveFullWidget };
